import { t } from '@lingui/macro'
import { exhaustiveGuard } from '@jotta/utils/exhaustive'
import type { ToastContent, ToastStatus } from './ToastProvider'
import type { BackgroundJobType } from '@jotta/hooks/useBackgroundJobStore'

export const getToastContent = (
  type: BackgroundJobType | 'EMPTY_TRASH',
  status: ToastStatus,
): ToastContent => {
  switch (type) {
    case 'MOVE':
      switch (status) {
        case 'IN_PROGRESS':
          return {
            message: t`Moving files`,
            isLoading: true,
          }
        case 'SUCCESS':
          return {
            message: t`Files moved`,
            hasCloseButton: true,
          }
        case 'FAILED':
          return {
            message: t`Failed to move files`,
            hasCloseButton: true,
          }
        default:
          return exhaustiveGuard(status)
      }
    case 'COPY':
      switch (status) {
        case 'IN_PROGRESS':
          return {
            message: t`Copying files`,
            isLoading: true,
          }
        case 'SUCCESS':
          return {
            message: t`Files copied`,
            hasCloseButton: true,
          }
        case 'FAILED':
          return {
            message: t`Failed to copy files`,
            hasCloseButton: true,
          }
        default:
          return exhaustiveGuard(status)
      }
    case 'MOVE_TO_TRASH':
      switch (status) {
        case 'IN_PROGRESS':
          return {
            message: t`Deleting files`,
            isLoading: true,
            minHeight: 90,
          }
        case 'SUCCESS':
          return {
            message: t`The files have been moved to the Trash and will be permanently deleted in 30 days.`,
            hasCloseButton: true,
            minHeight: 90,
          }
        case 'FAILED':
          return {
            message: t`Failed to delete files`,
            hasCloseButton: true,
            minHeight: 90,
          }
        default:
          return exhaustiveGuard(status)
      }
    case 'DELETE_PERMANENTLY':
      switch (status) {
        case 'IN_PROGRESS':
          return {
            message: t`Permanently deleting files`,
            isLoading: true,
          }
        case 'SUCCESS':
          return {
            message: t`Files deleted permanently`,
            hasCloseButton: true,
          }
        case 'FAILED':
          return {
            message: t`Failed to delete files permanently`,
            hasCloseButton: true,
          }
        default:
          return exhaustiveGuard(status)
      }
    case 'EMPTY_TRASH':
      switch (status) {
        case 'IN_PROGRESS':
          return {
            message: t`Emptying trash`,
            isLoading: true,
            minHeight: 52,
          }
        case 'SUCCESS':
          return {
            message: t`Trash emptied`,
            hasCloseButton: true,
            minHeight: 52,
          }
        case 'FAILED':
          return {
            message: t`Failed to empty trash`,
            hasCloseButton: true,
            minHeight: 52,
          }
        default:
          return exhaustiveGuard(status)
      }
    case 'RESTORE':
      switch (status) {
        case 'IN_PROGRESS':
          return {
            message: t`Restoring files`,
            isLoading: true,
            minHeight: 90,
          }
        case 'SUCCESS':
          return {
            message: t`Files restored`,
            hasCloseButton: true,
            minHeight: 90,
          }
        case 'FAILED':
          return {
            message: t`Failed to restore files`,
            hasCloseButton: true,
            minHeight: 90,
          }
        default:
          return exhaustiveGuard(status)
      }
    case 'DELETE_DEVICE':
      switch (status) {
        case 'IN_PROGRESS':
          return {
            message: t`Deleting device`,
            isLoading: true,
          }
        case 'SUCCESS':
          return {
            message: t`Device deleted`,
            hasCloseButton: true,
          }
        case 'FAILED':
          return {
            message: t`Failed to delete device`,
            hasCloseButton: true,
          }
        default:
          return exhaustiveGuard(status)
      }
    default:
      return exhaustiveGuard(type)
  }
}
